/**
 * Want to add more text? Go to custom/classes/calendar-text and add new properties there.
 */
export interface IPackageListingAppBaseSettings {
    numberOfPerformancesToDisplayByDefault: number;
    configId: number
    // Not from api but ~about~ api
    requesting: boolean;
    useUnseatedReservation: boolean;
    isFixed: boolean;
    apiError: any;
    smartSeatUrl: string;
    isRenewal: boolean;
    genre: string;
    availableText: string;
    limitedText: string;
    lowText: string;
    soldOutText: string;
}


export const defaultBaseSettings: IPackageListingAppBaseSettings = {
    numberOfPerformancesToDisplayByDefault: 0,
    configId: 0,
    useUnseatedReservation: false,
    isFixed: false,
    requesting: false,
    apiError: null,
    smartSeatUrl: "/smartseat/",
    isRenewal: false,
    genre: null,
    availableText: "Good Availability",
    limitedText: "Limited Availability",
    lowText: "Low Availiability",
    soldOutText: "Sold Out"
}